import { useMemo } from 'react';

import Permissions from '@/common/permissions';
import useHasAccess from '@/modules/core/hooks/useHasAccess';
import { useIsFraudPaymentHoldAvailable } from '@/modules/featureFlags';

export interface FraudReviewPermissions {
  isFeatureAvailable: boolean;
  canViewAlert: boolean;
  canManageFlag: boolean;
}

const useFraudReviewPermissions = (): FraudReviewPermissions => {
  const isFeatureAvailable = useIsFraudPaymentHoldAvailable();

  const hasAlertViewPermission = useHasAccess([{ permission: Permissions.FRAUD_MONITORING_ALERT_VIEW }]);
  const hasFlagPermission = useHasAccess([{ permission: Permissions.FRAUD_MONITORING_FLAG }]);

  return useMemo(
    () => ({
      isFeatureAvailable,
      canViewAlert: isFeatureAvailable && hasAlertViewPermission,
      canManageFlag: isFeatureAvailable && hasFlagPermission,
    }),
    [isFeatureAvailable, hasAlertViewPermission, hasFlagPermission]
  );
};

export default useFraudReviewPermissions;
